module.exports = __webpack_public_path__ + "static/09-007ff65e6ef5cb38cb3242fe8b1aa9c6.jpg";